import styled from "styled-components";
import { Theme } from "../../../../@types/theme";

interface BoxColorProps {
  color: string;
}

interface ProfileUserProps {
  isAnnonymous?: boolean;
}

export const ContainerModal = styled.form`
  max-width: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  background: ${({ theme }: Theme) => theme.colors.primary};
  -webkit-box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.11);
  box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.11);
  position: relative;
  border-radius: 10px;
  padding: 2rem 1.6rem;
  max-height: 420px;
  overflow-y: auto;

  button {
    border: none;
  }

  .icon-exit {
    width: 16.67px;
    height: 16.67px;
    position: absolute;
    right: 10px;
    top: 10px;
  }

  ::-webkit-scrollbar {
    width: 05px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: gray;
    border-radius: 130px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 1600px) {
    max-width: 600px;
    max-height: 300px;
  }

  @media (max-width: 1366px) {
    max-width: 500px;
    max-height: 300px;
  }
`;

export const Box = styled.div`
  display: flex;
  width: 100%;
  min-height: 73px;
  border-radius: 10px;
  align-items: center;
  border: solid 1px red;
  padding: 0 1.6rem;
  line-height: 190%;
  justify-content: center;
`;

export const Text = styled.span`
  color: black;
  font-size: 1.4rem;
  text-align: center;
  max-width: 783px;
  margin-bottom: 1rem;
`;

export const Wrapper = styled.div`
  display: flex;
  background: red;
  width: 100%;
  justify-content: space-between;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 227px;
  padding: 1rem 2rem;
  border-radius: 20px;

  &::placeholder {
    font-size: 1.6rem;
    font-weight: 400;
    color: ${({ theme }: Theme) => theme.colors.gray900};
  }
`;

export const HStack = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 2rem;
`;

export const HStackBtn = styled.div`
  display: flex;
  width: 160px;
  justify-content: center;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const Button = styled.button`
  width: 120px;
  height: 40px;
  background: ${({ theme }) => theme.colors.background};
  color: white;
  border-radius: 5px;

  transition: background 200ms linear;

  &:hover {
    background: black;
    color: white;
  }
`;

export const FooterWraper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  transform: translateY(5px);
`;

export const Left = styled.div`
  width: 6%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Right = styled.div`
  width: 94%;
  height: 100%;
  display: flex;
  align-items: center;

  span {
    line-height: 130%;
    font-weight: 400;
    font-size: 1.1rem;
  }
`;

export const InputHex = styled.input`
  width: 100px;
  height: 30px;
  padding: 0 0.5rem;

  &::placeholder {
    color: #c4c4c4;
    opacity: 0.6;
  }
`;

export const BoxColor = styled.div<BoxColorProps>`
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background: ${({ theme, color }) =>
    color == ""
      ? "conic-gradient(red, yellow, lime, aqua, blue, magenta, red)"
      : "red"};
  cursor: not-allowed;
  border: 1px solid black;
`;

export const ButtonBack = styled.button`
  width: 120px;
  height: 40px;
  background: white;
  color: black;
  border: 1px solid black;
  border-radius: 5px;
`;

export const Title = styled.span`
  font-weight: 400;
  font-size: 1.6rem;
  color: #343a40;

  @media (max-width: 1366px) {
    font-size: 1.4rem;
  }
`;

export const Line = styled.div`
  border-bottom: 1px solid #a5a5a5;
  width: 100%;
  height: 5px;
  margin: 1rem auto;
`;

export const HorizontalStack = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;

  @media (max-width: 1366px) {
    margin-bottom: 0.5rem;
  }
`;

export const InputBase = styled.input`
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #a5a5a5;
  border-radius: 10px;
  padding: 0 1rem;

  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),
    inset 0 0 0 100px rgba(255, 255, 255, 1);

  ::placeholder {
    color: #a5a5a5;
  }

  @media (max-width: 1366px) {
    max-height: 38px;
    border-radius: 8px;
  }
`;

export const FlexInput = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  padding-right: 1rem;
`;

export const ButtonShared = styled.button`
  height: 40px;
  background-color: black;
  color: white;
  padding: 0 1rem;
  margin-left: auto;
  border-radius: 10px;
  min-width: 130px;

  transition: background 120ms linear;

  :hover {
    background: ${({ theme }) => theme.colors.background};
  }

  .loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1366px) {
    max-height: 38px;
    border-radius: 8px;
    font-size: 1.2rem;
  }
`;

export const VerticalStack = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  margin-top: 1rem;
  flex-direction: column;
  /* padding-bottom: 2rem; */

  .containerLoading {
    width: 100%;
    min-height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 3rem auto;
  }

  @media (max-width: 1366px) {
    margin-top: 0;
  }
`;

export const WrapperProfileShared = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 49px;
  margin: 0.5rem 0rem;
  justify-content: space-between;

  .removeItem {
    width: 16px;
    height: 16px;
    transform: translateY(3px);
  }

  @media (max-width: 1600px) {
    .removeItem {
      width: 14px;
      height: 14px;
      transform: translateY(1px);
    }
  }

  @media (max-width: 1366px) {
    margin: 0.1rem 0rem;

    .removeItem {
      width: 12px;
      height: 12px;
      transform: translateY(1px);
    }
  }
`;

export const ButtonDeleteUserShared = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const AvatarContainer = styled.div`
  width: 10%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const NameContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
`;

export const ProfileUser = styled.span<ProfileUserProps>`
  font-size: 1.4rem;
  color: #343a40;
  align-items: center;
  transform: translateX(-10px) translateY(1px);
  opacity: ${({ isAnnonymous }) => isAnnonymous && "0.2"};

  @media (max-width: 1366px) {
    font-size: 1.2rem;
    margin-left: 0rem;
    transform: translateX(0px) translateY(0px);
  }
`;
